<span>{{ 'productDetails.new' | transloco }}</span>
